import { setupInterceptorsTo } from "./config";
import axios from "axios";
import { getAPIBaseURL } from "../../Helpers/urlUtility";

const instance = axios.create({
  baseURL: getAPIBaseURL(),
  timeout: 20000,
  withCredentials: false,
  headers: {
    "Content-Type": "application/json",
  },
});

export default setupInterceptorsTo(instance);
